import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_4 = { class: "mt-2 py-6 flex flex-col space-y-6 justify-center items-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium leading-6 text-center text-brand-text" }, " Section Info ", -1)
const _hoisted_6 = { class: "grid grid-cols-1 gap-6 w-full" }
const _hoisted_7 = { class: "block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "Title", -1)
const _hoisted_9 = { class: "block" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "Order", -1)
const _hoisted_11 = {
  key: 1,
  class: "flex flex-row space-x-4 justify-center w-full"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Delete", -1)
const _hoisted_17 = [
  _hoisted_16
]

import {computed, ref} from "vue";
import LoadingComponent from "@/components/LoadingComponent.vue";

import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {useCoursesStore} from "@/stores/coursesStore";
import {storeToRefs} from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddSectionDialog',
  props: {
    onClose: { type: Function },
    section: {}
  },
  setup(__props: any) {

const props = __props;

const section = computed(() => props.section)

const isEdit = ref(section.value !== null)

const closeDialog = () => {
  props.onClose?.()
}

const coursesStore = useCoursesStore()

const { loading, course } = storeToRefs(coursesStore)

const title = ref('')
const order = ref('')

if (section.value !== null) {
  title.value = section.value?.title ?? ""
  order.value = section.value?.order ?? ""
}

const saveSection = async (isDelete = false) => {
  if (title.value === '') {
    alert('Please fill all fields')
    return
  }
  try {
    let payload: any = {
      title: title.value,
      courseSlug: course.value?.slug,
      order: parseInt(order.value || '0')
    }
    if (isEdit.value) {
      payload = {
        ...payload,
        isEdit: isEdit.value,
        slug: section.value?.slug
      }
    }

    if(isDelete) {
      const response = confirm('Are you sure you want to delete this?')
      if (!response) {
        return
      }
      payload = {
        ...payload,
        isDelete: isDelete
      }
    }
    const response = await coursesStore.addSection(payload)
    if (response) {
      closeDialog()
    } else {
      alert('Failed to add course')
    }
  } catch (e) {
    console.error(e);
    alert('Failed to add course')
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: true
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-10",
        onClose: closeDialog
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "w-full max-w-md transform overflow-hidden rounded-2xl bg-brand-card p-6 text-left align-middle shadow-xl transition-all" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg font-bold leading-6 text-center text-brand-text"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(isEdit.value ? 'Edit Section' : 'Add Section'), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("label", _hoisted_7, [
                            _hoisted_8,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
                              class: "mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0",
                              placeholder: ""
                            }, null, 512), [
                              [_vModelText, title.value]
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_9, [
                            _hoisted_10,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((order).value = $event)),
                              class: "mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0",
                              placeholder: ""
                            }, null, 512), [
                              [_vModelText, order.value]
                            ])
                          ])
                        ]),
                        (_unref(loading))
                          ? (_openBlock(), _createBlock(LoadingComponent, { key: 0 }))
                          : _createCommentVNode("", true),
                        (!_unref(loading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] = () => saveSection(false)),
                                class: "bg-brand-secondary justify-center w-32 text-center text-white font-bold space-x-2 px-6 py-2 rounded-md flex flex-row"
                              }, _hoisted_13),
                              _createElementVNode("button", {
                                onClick: closeDialog,
                                class: "bg-red-500 justify-center w-32 text-center text-white font-bold space-x-2 px-6 py-2 rounded-md flex flex-row"
                              }, _hoisted_15),
                              (isEdit.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[3] || (_cache[3] = () => saveSection(true)),
                                    class: "border-red-500 text-red-500 border-2 justify-center w-32 text-center font-bold space-x-2 px-6 py-2 rounded-md flex flex-row"
                                  }, _hoisted_17))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})